import { render, staticRenderFns } from "./ReportDetailUnsettle.vue?vue&type=template&id=4ccb677e&"
import script from "./ReportDetailUnsettle.vue?vue&type=script&lang=js&"
export * from "./ReportDetailUnsettle.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailUnsettle.vue?vue&type=style&index=0&soped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReportDetailUnsettle.vue"
export default component.exports